export default "__VITE_ASSET__BLsRxCkr__"